import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6458c1a2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "HanoiTowerInferenceRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "根据左侧汉诺塔下方数字，推断每一列对应的计算规则。", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "规则交换后，请对右侧汉诺塔进行计算，并填写下方四个数字。", -1));
const _hoisted_5 = {
  class: "tower-stage mt24"
};
const _hoisted_6 = {
  class: "tower-panel"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, "原始规则", -1));
const _hoisted_8 = {
  class: "tower-columns"
};
const _hoisted_9 = {
  class: "tower"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tower-pole"
}, null, -1));
const _hoisted_11 = {
  class: "tower-rings"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tower-base"
}, null, -1));
const _hoisted_13 = {
  class: "tower-value"
};
const _hoisted_14 = {
  class: "swap-panel"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swap-label"
}, "规则交换位置", -1));
const _hoisted_16 = {
  class: "swap-value"
};
const _hoisted_17 = {
  class: "tower-panel"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, "交换后计算", -1));
const _hoisted_19 = {
  class: "tower-columns"
};
const _hoisted_20 = {
  class: "tower"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tower-pole"
}, null, -1));
const _hoisted_22 = {
  class: "tower-rings"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tower-base"
}, null, -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tower-value"
}, "?", -1));
const _hoisted_25 = {
  class: "answer-card mt24"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "answer-title"
}, "填写问号处数字", -1));
const _hoisted_27 = {
  class: "answer-slots"
};
const _hoisted_28 = ["disabled", "onClick"];
const _hoisted_29 = {
  key: 0,
  class: "keypad"
};
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
  key: 0,
  class: "review-card mt24"
};
const _hoisted_32 = {
  key: 0,
  class: "review-row"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "review-label"
}, "原规则", -1));
const _hoisted_34 = {
  class: "review-items"
};
const _hoisted_35 = {
  key: 1,
  class: "review-row"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "review-label"
}, "交换后规则", -1));
const _hoisted_37 = {
  class: "review-items"
};
const _hoisted_38 = {
  class: "review-row"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "review-label"
}, "正确答案", -1));
const _hoisted_40 = {
  class: "review-items"
};
const _hoisted_41 = {
  class: "review-row"
};
const _hoisted_42 = {
  key: 0,
  class: "review-items"
};
const _hoisted_43 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_tag = _resolveComponent("el-tag");
  return $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16 guide-text"
  }, {
    default: _withCtx(() => [_hoisted_3, _hoisted_4]),
    _: 1
  }), _createElementVNode("div", _hoisted_5, [_createElementVNode("section", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.leftColumns, (column, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: `left_${index}`,
      class: "tower-column-block"
    }, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.rings, (ring, ringIndex) => {
      return _openBlock(), _createElementBlock("div", {
        key: `left_${index}_${ringIndex}`,
        class: _normalizeClass(["tower-ring", ring === 'R' ? 'ring-red' : 'ring-blue'])
      }, null, 2);
    }), 128))]), _hoisted_12]), _createElementVNode("div", _hoisted_13, _toDisplayString(column.value), 1)]);
  }), 128))])]), _createElementVNode("section", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString($props.data.swap?.from) + "-" + _toDisplayString($props.data.swap?.to), 1)]), _createElementVNode("section", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.rightColumns, (column, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: `right_${index}`,
      class: "tower-column-block"
    }, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.rings, (ring, ringIndex) => {
      return _openBlock(), _createElementBlock("div", {
        key: `right_${index}_${ringIndex}`,
        class: _normalizeClass(["tower-ring", ring === 'R' ? 'ring-red' : 'ring-blue'])
      }, null, 2);
    }), 128))]), _hoisted_23]), _hoisted_24]);
  }), 128))])])]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.answerSlots, (slot, index) => {
    return _openBlock(), _createElementBlock("button", {
      key: `slot_${index}`,
      type: "button",
      class: _normalizeClass(["answer-slot", {
        active: $data.activeIndex === index,
        readonly: $props.reviewMode
      }]),
      disabled: $props.reviewMode,
      onClick: $event => $options.setActive(index)
    }, _toDisplayString(slot === null ? '?' : slot), 11, _hoisted_28);
  }), 128))]), !$props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.digits, num => {
    return _openBlock(), _createElementBlock("button", {
      key: `digit_${num}`,
      type: "button",
      class: "keypad-btn",
      onClick: $event => $options.inputDigit(num)
    }, _toDisplayString(num), 9, _hoisted_30);
  }), 128)), _createElementVNode("button", {
    type: "button",
    class: "keypad-btn action-btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.removeDigit && $options.removeDigit(...args))
  }, "删除"), _createElementVNode("button", {
    type: "button",
    class: "keypad-btn action-btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.clearDigits && $options.clearDigits(...args))
  }, "清空")])) : _createCommentVNode("", true)]), $props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_31, [$props.data.originalRules?.length ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.originalRules, (rule, index) => {
    return _openBlock(), _createBlock(_component_el_tag, {
      key: `origin_${index}`,
      type: "info"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(index + 1) + "列：" + _toDisplayString($options.ruleLabel(rule)), 1)]),
      _: 2
    }, 1024);
  }), 128))])])) : _createCommentVNode("", true), $props.data.swappedRules?.length ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_hoisted_36, _createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.swappedRules, (rule, index) => {
    return _openBlock(), _createBlock(_component_el_tag, {
      key: `swapped_${index}`,
      type: "warning"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(index + 1) + "列：" + _toDisplayString($options.ruleLabel(rule)), 1)]),
      _: 2
    }, 1024);
  }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.correctAnswers, (item, index) => {
    return _openBlock(), _createBlock(_component_el_tag, {
      key: `correct_${index}`,
      type: "success"
    }, {
      default: _withCtx(() => [_createTextVNode(" 第" + _toDisplayString(index + 1) + "列：" + _toDisplayString(item), 1)]),
      _: 2
    }, 1024);
  }), 128))])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("span", {
    class: "review-label",
    style: _normalizeStyle({
      color: $props.review?.result ? '#27ae60' : '#e74c3c'
    })
  }, "您的答案", 4), $options.reviewAnswers.length ? (_openBlock(), _createElementBlock("div", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.reviewAnswers, (item, index) => {
    return _openBlock(), _createBlock(_component_el_tag, {
      key: `review_${index}`,
      type: $options.correctAnswers[index] === item ? 'success' : 'danger'
    }, {
      default: _withCtx(() => [_createTextVNode(" 第" + _toDisplayString(index + 1) + "列：" + _toDisplayString(item), 1)]),
      _: 2
    }, 1032, ["type"]);
  }), 128))])) : (_openBlock(), _createElementBlock("span", _hoisted_43, "未作答"))])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}